<template>
    <div v-if="Object.keys(contract).length" class="mb-4 p-2">
        <div class="row no-print">
            <div class="col card m-2 p-1">
                <div class="d-flex justify-content-between">
                    <h4 class="ml-2 mb-0 mt-1">{{ $t('Contract') }} #{{ contract.num }}</h4>
                    <div>
                        <app-button v-if="$store.getters.canDeleteContracts" native-type="button" type="danger" class="float-right" @click="destroy(contract.id)" small>
                            <fa-icon :icon="['fa', 'trash-alt']"/>
                        </app-button>
                        <app-button v-if="$store.getters.canViewContracts" :loading="pdf_loading" native-type="button" type="warning" class="float-right text-white" @click="pdf(contract.id, contract.num, 'en')" small>
                            <fa-icon :icon="['fa', 'file-pdf']"/> ENG
                        </app-button>
                        <app-button v-if="$store.getters.canViewContracts" :loading="pdf_loading" native-type="button" type="info" class="float-right text-white" @click="pdf(contract.id, contract.num, 'et')" small>
                            <fa-icon :icon="['fa', 'file-pdf']"/> EST
                        </app-button>
                        <router-link v-if="$store.getters.canViewClients && (booking.client_id || contract.client_id)" :to="{name: 'clients.show', params: {client_id: booking.client_id || contract.client_id}}" class="btn btn-info btn-sm float-right text-white">
                            {{ $t('View client') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col card p-3 mx-2">
                <div class="d-flex justify-content-between">
                    <h4>{{ $t('Rentee') }}</h4>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Name') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.name }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Id code') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.idcode }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Drivers license no') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.drivers_license }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Passport no') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.passport }}</p>
                        </div>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Address') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.address }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Phone') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.phone }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Email') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.email }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Creditcard no') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.cc_no }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Creditcard expiry') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.rentee.cc_validity }}</p>
                        </div>
                    </div>
                </div>
                <h4 class="mt-3 mb-0">{{ $t('Company') }}</h4>
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Name') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.company.name }}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Reg no') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.company.name }}</p>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Invoice email') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.company.email }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Equipment/services') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.info.eq_and_serv }}</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12" :class="{'no-print': !contract.info.extra_info}">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Extra info') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.info.extra_info }}</p>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col">
                        <h4>{{ $t('Rental prices') }}</h4>
                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Days') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.days }}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">
                                        {{ $t('Day price') }}
                                    </label>
                                    <p class="custom-gray-input-bg">
                                        {{ booking.prices.avg_price }} €
                                    </p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Eqipment price') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.eq_total }} €</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Services') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.service_total }} €</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Extra hours') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.over_hrs }}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Extra hour price') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.hr_price }} €</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Bond') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.bond }} €</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group mb-1">
                                    <label class="mb-0">{{ $t('Total price') }}</label>
                                    <p class="custom-gray-input-bg">{{ booking.prices.total }} €</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="booking.early_return_location_id || booking.early_return_at" class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Early return date & time') }}</label>
                            <p class="custom-gray-input-bg">{{ booking.early_return_at | formatDateTime }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Early return to') }}</label>
                            <p class="custom-gray-input-bg">{{ locations.find(c => c.id === booking.early_return_location_id).name[locale] }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div v-if="booking.promo">
                            <div class="form-group mb-1">
                                <label class="mb-0">{{ $t('Promocode') }}</label>
                                <p class="custom-gray-input-bg">"{{ booking.promo.code }}" <small>-{{ booking.promo.discount_percent }}%</small></p>
                            </div>
                        </div>
                        <div v-else-if="booking.client_id !== null">
                            <div class="form-group mb-1">
                                <label class="mb-0">{{ $t('Client') }}</label>
                                <p class="custom-gray-input-bg">{{ booking.client.name }} <small>-{{ booking.client.discount_percent }}%</small></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col card p-3 mx-2">
                <div class="d-flex justify-content-between">
                    <h4>{{ $t('Vehicle') }}</h4>
                    <router-link v-if="booking.vehicle_id" :to="{name: 'vehicles.show', params: {vehicle_id: booking.vehicle_id}}" class="btn btn-info btn-sm text-white">
                        {{ $t('Vehicle') }}
                    </router-link>
                </div>
                <h5 class="custom-gray-input-bg">{{ getVehicleName(booking.vehicle) }}</h5>
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Start date') }} & {{ $t('Return date') }}</label>
                    <p class="custom-gray-input-bg">{{ booking.start_time | formatDateTime }} - {{ booking.end_time | formatDateTime }}</p>
                </div>
                <div class="row mt-3">
                    <div class="col-md-3 col-sm-12 d-flex align-items-center">
                        <app-checkbox id="additional_drivers" v-model="contract.info.additional_drivers" name="additional_drivers" disabled>
                            {{ $t('Additional drivers permitted') }}
                        </app-checkbox>
                    </div>
                    <div class="col-md-3 col-sm-12 d-flex align-items-center">
                        <app-checkbox id="vehicle_clean" v-model="contract.info.vehicle_clean" name="vehicle_clean" disabled>
                            {{ $t('Vehicle clean') }}
                        </app-checkbox>
                    </div>
                    <div class="col-md-3 col-sm-12 d-flex align-items-center">
                        <app-checkbox id="smoking" v-model="contract.info.smoking" name="smoking" disabled>
                            {{ $t('Smoking in the car') }}
                        </app-checkbox>
                    </div>
                    <div class="col-md-3 col-sm-12">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Suitsetamise trahv') }}</label>
                            <p class="custom-gray-input-bg">{{ smoking_fine }}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Liability') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.info.liability_sum }}</p>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Tank level') }}</label>
                            <p class="custom-gray-input-bg">{{ contract.info.tank_level }}</p>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Damages') }}</label>
                    <p class="custom-gray-input-bg">{{ contract.info.hasOwnProperty('vehicle_damages') ? contract.info.vehicle_damages[locale] : '' }}</p>
                </div>
                <h4 class="mb-0">{{ $t('Period') }}</h4>
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Start date') }} & {{ $t('Return date') }}</label>
                    <p class="custom-gray-input-bg">{{ booking.start_time | formatDateTime }} - {{ booking.end_time | formatDateTime }}</p>
                </div>
                <div v-if="locations.length" class="row">
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Pick up from') }}</label>
                            <p class="custom-gray-input-bg">{{ locations.find(c => c.id === booking.pickup_location_id).name[locale] }}</p>
                            <template v-if="booking.pickup_location_id === otherLocationId">
                                <p class="custom-gray-input-bg">{{ booking.pickup_location_custom }}</p>
                            </template>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group mb-1">
                            <label class="mb-0">{{ $t('Return to') }}</label>
                            <p class="custom-gray-input-bg">{{ locations.find(c => c.id === booking.return_location_id).name[locale] }}</p>
                            <template v-if="booking.return_location_id === otherLocationId">
                                <p class="custom-gray-input-bg">{{ booking.return_location_custom }}</p>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-1">
                    <label class="mb-0">{{ $t('Permitted countries') }}</label>
                    <p class="custom-gray-input-bg">{{ contract.info.permitted_countries }}</p>
                </div>
                <template v-if="booking.travel_out" class="mt-2">
                    <div>
                        <span class="mdi mdi-18px mdi-alert-outline text-danger"/> {{ $t('Travel out of Estonia') }}: <b>{{ booking.travel_out }}</b>
                    </div>
                </template>
                <div class="row mt-2">
                    <div class="col-md-6 col-sm-12">
                        <div class="accordion" id="ad_eqs">
                            <div class="card shadow-none">
                                <div class="card-header pointer accordeon-border" data-toggle="collapse" href="#additional_equipment">
                                    <a class="card-link font-weight-normal pl-1">
                                        {{ $t('Additional eq') }}
                                        <fa-icon :icon="['fas', 'angle-down']" pull="right"/>
                                    </a>
                                </div>
                                <div id="additional_equipment" class="collapse show pt-3" aria-labelledby="headingL-varustus" data-parent="#ad_eqs">
                                    <app-custom-checkbox v-for="(eq, j) in additions"
                                                         :id="`eq_${j}`"
                                                         :name="`eq_${j}`"
                                                         :key="j"
                                                         :value="booking.additional_eq.map(e => e.id).includes(eq.id)"
                                                         disabled>
                                        {{ $t(eq.name[locale]) }}
                                    </app-custom-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="accordion" id="services_acc">
                            <div class="card shadow-none">
                                <div class="card-header pointer accordeon-border" data-toggle="collapse" href="#services">
                                    <a class="card-link font-weight-normal pl-1">
                                        {{ $t('Services') }}
                                        <fa-icon :icon="['fas', 'angle-down']" pull="right"/>
                                    </a>
                                </div>
                                <div id="services" class="collapse show" aria-labelledby="headingL-varustus" data-parent="#services_acc">
                                    <div class="card-body">
                                        <template v-if="booking.services.length">
                                            <p class="mb-1" v-for="(serv, s) in booking.services" :key="`s_${s}`">
                                                {{ serv.name[locale] }}, <strong :key="`se_${s}`">{{ (serv.price / 100).toFixed(2) }}€</strong><br :key="`ser_${s}`"/>
                                            </p>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContractService from '@services/contract.service';
import {mapGetters} from 'vuex';
import AdditionService from '@services/addition.service';
import LocationService from '@services/location.service';
import pdfMixin from './pdf.mixin';

export default {
    mixins: [pdfMixin],
    data() {
        return {
            smoking_fine: null,
            booking: {},
            contract: {},
            locations: [],
            additions: [],
        };
    },
    computed: {
        ...mapGetters(['locale', 'langs', 'otherLocationId'])
    },
    methods: {
        getLocations() {
            LocationService.locations().then(res => {
                this.locations = res;
                this.getAdditions();
            });
        },
        getVehicleName(vehicle) {
            if (vehicle) {
                return `${vehicle.make.name} ${vehicle.model.name} ${vehicle.slug ? vehicle.slug.slice(-1) : ''}, ${vehicle.reg_no}`;
            }
            return vehicle;
        },
        getContract(contractId) {
            ContractService.contract(contractId).then(res => {
                this.smoking_fine = res.smoking_fine;
                this.contract = res.value;
                this.contract.id = res.id;
                this.contract.num = res.num;
                this.booking = res.booking_id == null ? res.value.booking : res.booking;
                this.setPrices(this.booking.prices);
                this.getLocations();
            });
        },
        setPrices(prices) {
            this.booking.prices.eq_total = (prices.eq_total / 100).toFixed(2);
            this.booking.prices.service_total = (prices.service_total / 100).toFixed(2);
            this.booking.prices.avg_price = (prices.avg_price / 100).toFixed(2);
            this.booking.prices.days = prices.days;
            this.booking.prices.bond = prices.bond / 100;
            this.booking.prices.total = (prices.total / 100).toFixed(2);
            this.booking.prices.hr_price = (prices.hr_price / 100).toFixed(2);
            this.booking.prices.over_hrs = prices.over_hrs;
        },
        additionNames(additionIds) {
            let addEqs = [];
            additionIds.map(id => {
                addEqs.push(this.additions.some(add => add.id === id) ? this.additions.find(add => add.id === id).name : {});
            });
            return addEqs;
        },
        getAdditions() {
            AdditionService.additions().then(res => this.additions = res);
        },
        destroy(contractId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            ContractService.destroy(contractId).then(res => {
                this.$toastr.s(this.$t('Deleted'));
                this.$router.push({name:'contracts'});
            });
        }
    },
    created() {
        this.getContract(this.$route.params.contract_id);
        this.getAdditions();
    }
};
</script>
